import { get, post, put, del } from 'utils/methods';

export function getQuoteApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}quotes`, data, headers);
}

export function addNewQuoteApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/quote`, data, headers);
}

export function editQuoteApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_ORDERS}commands/quote`, data, headers);
}

export function attachBillingAccountToQuoteApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/quote/billing-account`, data, headers);
}

export function cancelQuoteApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/quote/status`, data, headers);
}

export function cloneQuoteApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/quote/clone`, data, headers);
}

export function changeQuoteStatusApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_ORDERS}commands/quote/status`, data, headers);
}

export function addQuoteItemApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order-item`, data, headers);
}

export function deleteQuoteItemApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_ORDERS}commands/order-item`, data, headers);
}

export function editQuoteItemApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_ORDERS}commands/order-item`, data, headers);
}

export function addQuoteAdditionalItemApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/quote/additional-item`, data, headers);
}

export function deleteQuoteAdditionalItemApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_ORDERS}commands/quote/additional-item`, data, headers);
}

export function addFavorisQuoteApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_USERS}commands/favorite-quote`, data, headers);
}

export function deleteFavorisQuoteApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_USERS}commands/favorite-quote`, data, headers);
}
